import React from 'react';
import {Oval} from 'react-loader-spinner';
import {defaultTheme} from "../../styles/themes/default";

interface LoadingComponentProps {
        size?: number,
        strokeWidth?: number
}

export const LoadingComponent = ({size=80, strokeWidth=2}: LoadingComponentProps) => <Oval
            height={size}
            width={size}
            color={defaultTheme.grayDark}
            wrapperClass=""
            visible
            ariaLabel="oval-loading"
            secondaryColor={defaultTheme.gray}
            strokeWidth={strokeWidth}
            strokeWidthSecondary={strokeWidth}
        />

export default LoadingComponent;
